import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { ApiPageResponse } from '../types/api.types';
import {
  AccountInDebtView,
  LedgerEntryResponse,
  OwnerType,
  WalletSnapshotResponse,
} from '../types/wallet.types';

@Injectable({ providedIn: 'root' })
export class WalletsService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.gatewayUrl}/wallet/api`;

  /** Wallet snapshot for an actor — `GET /accounts/{ownerType}/{ownerRef}`. */
  getSnapshot(ownerType: OwnerType, ownerRef: number): Observable<WalletSnapshotResponse> {
    return this.http.get<WalletSnapshotResponse>(
      `${this.base}/accounts/${ownerType}/${ownerRef}`,
    );
  }

  /**
   * Paginated list of prestataires (OWNER / DRIVER / OPERATOR) whose CREDIT
   * is in debt. `page` is **1-indexed** (Nawam convention — aligned by the
   * wallet-service controllers wrapping responses with `ResponseHandler`).
   */
  prestatairesInDebt(
    ownerType: OwnerType,
    page = 1,
    size = 20,
  ): Observable<ApiPageResponse<AccountInDebtView>> {
    const params = new HttpParams()
      .set('ownerType', ownerType)
      .set('page', String(page))
      .set('size', String(size));
    return this.http.get<ApiPageResponse<AccountInDebtView>>(
      `${this.base}/admin/prestataires-in-debt`,
      { params },
    );
  }

  /** Ledger history for an account — `GET /ledger/account/{accountId}`. */
  ledgerByAccount(
    accountId: number,
    page = 1,
    size = 20,
  ): Observable<ApiPageResponse<LedgerEntryResponse>> {
    const params = new HttpParams()
      .set('page', String(page))
      .set('size', String(size));
    return this.http.get<ApiPageResponse<LedgerEntryResponse>>(
      `${this.base}/ledger/account/${accountId}`,
      { params },
    );
  }
}
